// nécéssite jquery et vegas

require('url-polyfill');
require('./hapi-background-slides.scss');

var backgroundSlides = [];

var backgroundSlideSynchedVegasCommands = function(vegas_container, command) {
	var wrapper = $(vegas_container).parents('.background-slides-init').eq(0);
	var syncgroup = $(wrapper).data('backgroundSlidesSyncgroup');
	var target = $(vegas_container)
	if(syncgroup)
	{
		target = $('.background-slides-init[data-background-slides-syncgroup="'+syncgroup+'"] .vegas-container');
	}

	target.each(function(){
		var _wrapper = $(this).parents('.background-slides-init').eq(0);
		if(command=='next'     && _wrapper.data('backgroundSlidesTransition')=='slideHorizontal')
			$(this).vegas('options', 'transition', 'slideLeft');
		if(command=='previous' && _wrapper.data('backgroundSlidesTransition')=='slideHorizontal')
			$(this).vegas('options', 'transition', 'slideRight');

		if(command=='next'     && _wrapper.data('backgroundSlidesTransition')=='slideVertical')
			$(this).vegas('options', 'transition', 'slideDown');
		if(command=='previous' && _wrapper.data('backgroundSlidesTransition')=='slideVertical')
			$(this).vegas('options', 'transition', 'slideUp');
	})

	target.vegas(command);
}

var backgroundSlideprocessDimension = function(W,H,image_hd_url,cropmode) {
    if (typeof image_hd_url === 'string') {
        if (image_hd_url.match(/api\.hapidam\.com\/share\/[^?]+\?/)) {
            return backgroundSlideprocessDimension_Hapidam(W,H,image_hd_url,cropmode);
        } else {
            return backgroundSlideprocessDimension_Local(W,H,image_hd_url,cropmode);
        }
    }
}

var backgroundSlideprocessDimension_Local = function(W,H,image_hd_url,cropmode)
{
	var result = image_hd_url;

	if(W>0 && H>0)
	{
		var _W = ImageRsz_SizeBreakpoint(W)
		var _H = ImageRsz_SizeBreakpoint(H)


		if(image_hd_url.match(/\/(media|hapidam|instagram)\//))
		{
			var url = new URL(image_hd_url);
			/*
			var w = url.searchParams.get("w");
			var h = url.searchParams.get("h");
			var s = url.searchParams.get("s");
			*/
			var coi = url.searchParams.get("coi");
			var mode = url.searchParams.get("mode");
			var hash = url.searchParams.get("hash");

			hash = ImageRsz_HASH(hash)
			//mode = ImageRsz_MODE(mode)
			mode = 'crop'
			coi = ImageRsz_COI(coi);

			result = url.origin+url.pathname+'?w='+_W+'&h='+_H+'&coi='+coi+'&mode='+mode+'&hash='+hash;
		}

		return {
			url:result,
			W:_W,
			H:_H,
			coi:coi,
		};
	}
	return false;
}

var backgroundSlideprocessDimension_Hapidam = function(W,H,image_hd_url,cropmode)
{
	var result = image_hd_url;

	//console.log('---------------------');
	if(W>0 && H>0)
	{
		var _W = ImageRsz_SizeBreakpoint(W)
		var _H = ImageRsz_SizeBreakpoint(H)

		var url = new URL(image_hd_url);
		/*
		var w = url.searchParams.get("w");
		var h = url.searchParams.get("h");
		*/
		var coi = url.searchParams.get("coi");
		var mode = url.searchParams.get("mode");

		//mode = ImageRsz_MODE(mode)
		mode = 'crop'
		coi = ImageRsz_COI(coi);

		result = url.origin+url.pathname+'?mode='+mode+'&w='+_W+'&h='+_H+'&coi='+coi;

		return {
			url:result,
			W:_W,
			H:_H,
			coi:coi,
		};
	}
	return false;
}

var backgroundSlideFullscreenOpen = function(container)
{
	var slides = JSON.parse($(container).attr('data-background-slides'));
	$.fancybox.open( slides, {
		index: $(container).data('slider-handler').vegas('current'),
		padding: 0,
		transitionIn: 'none',
		transitionOut: 'none',
		type: 'image',
		changeFade: 0,
		touch: true,
		loop:true,
		btnTpl: {
			arrowLeft:
				'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
					'<i class="fas fa-2x fa-angle-left"></i>' +
				"</button>",
			arrowRight:
				'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
					'<i class="fas fa-2x fa-angle-right"></i>' +
				"</button>",
		},
	});
}

var backgroundSlideInit = function(){
	$('[data-background-slides]:not(.background-slides-init)').each(function(){
		const sliderMainContainer = this;
		if($(sliderMainContainer).outerHeight()>0)
		{

			$(sliderMainContainer).addClass('background-slides-init');
			var slides = $(sliderMainContainer).data('backgroundSlides');

			var W = $(sliderMainContainer).outerWidth();
			var H = $(sliderMainContainer).outerHeight();

			var cropmode = '';
			if(W<150 || H<150)
			{
				var $cell = $(sliderMainContainer).parents('.grid_cell').eq(0);
				if($cell)
				{
					W = $cell.outerWidth();
					H = $cell.outerHeight();
				}
				else
				{
					cropmode = '';
				}
			}

			// Fix slides SRC dimension
			for(let i = 0;i<slides.length; i++)
			{
				//console.log('before',slides[i].src)
				var fixedUrl = backgroundSlideprocessDimension(W,H,slides[i].src,cropmode);
				slides[i].src = fixedUrl ? fixedUrl.url : slides[i].src;
				//console.log('after',slides[i].src)
			}

			var autoplay = $(sliderMainContainer).data('backgroundSlidesAutoplay');

			var fullscreen = $(sliderMainContainer).data('backgroundSlidesFullscreen');

			var speed = $(sliderMainContainer).data('backgroundSlidesSpeed');
			speed = typeof speed=='undefined' ? 1000 : parseFloat(speed)*1000;

			var timeout = $(sliderMainContainer).data('backgroundSlidesTimeout');
			timeout = typeof timeout=='undefined'  ? 4000 : speed + parseFloat(timeout)*1000 + 1;

			var legend = $(sliderMainContainer).data('backgroundSlidesLegend');
			legend = typeof legend=='undefined'  ? false : (legend ? true:false);

			var copyright = $(sliderMainContainer).data('backgroundSlidesCopyright');
			copyright = typeof copyright=='undefined'  ? false : (copyright ? true:false);

			var pager = $(sliderMainContainer).data('backgroundSlidesPager');
			pager = typeof pager=='undefined'  ? false : (pager ? true:false);

			var syncgroup = $(sliderMainContainer).data('backgroundSlidesSyncgroup');
			syncgroup = typeof syncgroup=='undefined' || syncgroup.trim()==''  ? false : syncgroup;

			if(ENV_ADMIN)
			{
				var recap = $('<dl class="background-slides-recap"><dt><i class="fas fa-images"></i></dt></dl>')
				if(syncgroup)
					$(recap).append('<dd>'+syncgroup+'</dd>')
				if($(recap).find('dd').length>0)
					$(sliderMainContainer).append(recap);
			}

			if($(window).width()>980)
			{
				var transition = $(sliderMainContainer).data('backgroundSlidesTransition');
				var progressbar = $(sliderMainContainer).data('backgroundSlidesProgressbar');
				var pausehover = $(sliderMainContainer).data('backgroundSlidesPausehover');
			}
			else
			{
				var transition = $(sliderMainContainer).data('backgroundSlidesTransitionMobile');
				var progressbar = $(sliderMainContainer).data('backgroundSlidesProgressbarMobile');
				var pausehover = false;
			}

			var vegas_container = $('<div class="slide-as-background"></div>')
			backgroundSlides.push({
				container:vegas_container,
				autoplay:autoplay,
				timeout:timeout,
				speed:speed,
			});

			$(sliderMainContainer).prepend(vegas_container);
			var slider = $(vegas_container).vegas({
				autoplay: autoplay ? true:false,
				timer: progressbar ? true:false,
				transition: transition ? transition : 'fade',
				slides: slides,
				transitionDuration: speed,
				delay:timeout,
				walk: function (slides, index, slideSettings) {
					var wrapper = $(vegas_container).parents('.background-slides-init').eq(0);

					if(wrapper.data('backgroundSlidesTransition')=='slideHorizontal')
						$(vegas_container).vegas('options','transition','slideLeft');

					if(wrapper.data('backgroundSlidesTransition')=='slideVertical')
						$(vegas_container).vegas('options','transition','slideDown');

					if(slides[index].legend)
						$(vegas_container).find('.vegas-wrapper .legend span').html(slides[index].legend).show();
					else
						$(vegas_container).find('.vegas-wrapper .legend span').hide().html('');

					if(slides[index].copyright)
						$(vegas_container).find('.vegas-wrapper .legend em').html(slides[index].copyright).show();
					else
						$(vegas_container).find('.vegas-wrapper .legend em').hide().html('');

					$(vegas_container).find('.vegas-wrapper .pager span.active').removeClass('active');
					$(vegas_container).find('.vegas-wrapper .pager span').eq(index).addClass('active');

					$(vegas_container).find('.vegas-wrapper .btn-counter span').html((index+1)+'/'+slides.length);

				}.bind(null,slides)
			});

			$(sliderMainContainer).data('slider-handler',slider);

			if(fullscreen)
			{
				$(sliderMainContainer).on('click',function(e){
					e.stopPropagation();
					e.preventDefault();
					backgroundSlideFullscreenOpen(sliderMainContainer);
				});
			}

			var fullscreen_btn = $('<div class="btn-fs"><span class="btn-fs-body"><i class="far fa-expand"></i></span></div>');
			$(vegas_container).find('.vegas-wrapper').append(fullscreen_btn);
			fullscreen_btn.on('click',function(e){
				e.stopPropagation();
				e.preventDefault();
				backgroundSlideFullscreenOpen(sliderMainContainer);
			});

			var slider_counter = $('<div class="btn-counter"><span>../..</span></div>');
			$(vegas_container).find('.vegas-wrapper').append(slider_counter);

			$(vegas_container).height('100%');

			const btn_previous = $('<div class="btn-previous"><span class="my-btn-prev"><i class="fas fa-angle-left"></i></span></div>');
			$(vegas_container).find('.vegas-wrapper').append(btn_previous);
			btn_previous.on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				backgroundSlideSynchedVegasCommands(vegas_container,'previous')
			});

			const btn_next = $('<div class="btn-next"><span class="my-btn-next"><i class="fas fa-angle-right"></i></span></div>')
			$(vegas_container).find('.vegas-wrapper').append(btn_next);
			btn_next.on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				backgroundSlideSynchedVegasCommands(vegas_container,'next')
			});

			var swipeListener = SwipeListener(sliderMainContainer);
			sliderMainContainer.addEventListener('swipe', function(e){
				if(e && e.detail && e.detail.directions && e.detail.directions.left)
				{
					backgroundSlideSynchedVegasCommands($(sliderMainContainer).find('.vegas-container'),'next')
					e.preventDefault();
					e.stopPropagation();
				}
				else if(e && e.detail && e.detail.directions && e.detail.directions.right)
				{
					backgroundSlideSynchedVegasCommands($(sliderMainContainer).find('.vegas-container'),'previous')
					e.preventDefault();
					e.stopPropagation();
				}
			});

			if(legend || copyright)
				$(vegas_container).find('.vegas-wrapper').append('<div class="legend"><span></span> <em></em></div>');

			if(pager)
			{
				$(vegas_container).find('.vegas-wrapper').append('<div class="pager"></div>');
				for(var i=0;i<slides.length;i++)
					$(vegas_container).find('.vegas-wrapper .pager').append('<span data-index="'+i+'">'+(i+1)+'</span>');

				$(vegas_container).find('.vegas-wrapper .pager span:first-child').addClass('active');
				$(vegas_container).find('.vegas-wrapper .pager span').on('click',function(){
					$(vegas_container).vegas('jump',$(this).data('index'));
				})
			}

			if(pausehover)
			{
				$(vegas_container).parent().on('mouseover',function(vegas_container){
					var timer = $(vegas_container).data('vegas_resume_timeout');
					clearTimeout(timer);
					$(vegas_container).vegas('pause')
				}
				.bind(null,vegas_container));

				$(vegas_container).parent().on('mouseout',function(vegas_container){
					var timer = $(vegas_container).data('vegas_resume_timeout');
					clearTimeout(timer);
					timer = setTimeout(function(vegas_container){
						$(vegas_container).vegas('play')
					}
					.bind(null,vegas_container),(timeout-speed)*0.75);
					$(vegas_container).data('vegas_resume_timeout',timer);
				}
				.bind(null,vegas_container));
			}
		}
	});
}

$( document ).ready(function() {
	setInterval(backgroundSlideInit,1000);
});

var backgroundSlideAutomaticPlayOnScroll = function()
{
	for(var i=0; i<backgroundSlides.length; i++)
	{
		var item = backgroundSlides[i];
		if(item.autoplay){
			if(backgroundSlideAutomaticPlayOnScroll_isInViewport(item.container[0]))
			{
				//console.log('vegas-start',item.container[0]);
				var timer = item.container.data('vegas_resume_timeout');
				clearTimeout(timer);
				var timer = setTimeout(function(vegas_container){
					$(vegas_container).vegas('play');
				}
				.bind(null,item.container),(item.timeout-item.speed)*0.75);
				item.container.data('vegas_resume_timeout',timer);
			}
			else
			{
				//console.log('vegas-stop',item.container[0]);
				var timer = item.container.data('vegas_resume_timeout');
				clearTimeout(timer);
				item.container.vegas('pause');
			}
		}
	}
}

function backgroundSlideAutomaticPlayOnScroll_isInViewport(element) {
  var rect = element.getBoundingClientRect();
  var html = document.documentElement;
  //console.debug(rect);
  var delta = -$(window).height()/4;
  return (
	true
	&& rect.bottom >= -delta
	&& rect.top <= (window.innerHeight || html.clientHeight) + delta
  );
}

var backgroundSlideAutomaticPlayOnScroll_timeout = null;
$(window).on('scroll',function(){
	clearTimeout(backgroundSlideAutomaticPlayOnScroll_timeout);
	backgroundSlideAutomaticPlayOnScroll_timeout = setTimeout(backgroundSlideAutomaticPlayOnScroll, 100);
});
setTimeout(backgroundSlideAutomaticPlayOnScroll,250);
setTimeout(backgroundSlideAutomaticPlayOnScroll,500);
